import { AxiosResponse } from "axios";
import { EventFieldsModel } from "../../type/entities/events-type";
import { RestServiceConnection } from "../restServiceConnection";

const ENDPOINT = '/events';

export class EventsService extends RestServiceConnection {

    /**
     * EN: List events configurations with filters and pagination.
     *
     * ES: Listar configuraciones de eventos con filtros y paginación.
     *
     * @param filters
     * @returns
     */
    listEvents = async (filters?: any) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/list',
            data: filters,
        }, true) as AxiosResponse;
        return this;
    }

    /**
     * EN: Get a single event configuration by ID.
     *
     * ES: Obtener una configuración de evento por ID.
     *
     * @param id
     * @returns
     */
    getEventById = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/get',
            data: { id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    /**
     * EN: Create a new event configuration.
     *
     * ES: Crear una nueva configuración de evento.
     *
     * @param data
     * @returns
     */
    createEvent = async (data: EventFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/create',
            data,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    /**
     * EN: Edit an existing event configuration.
     *
     * ES: Editar una configuración de evento existente.
     *
     * @param data
     * @returns
     */
    editEvent = async (data: EventFieldsModel) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/edit',
            data,
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    /**
     * EN: Delete an event configuration.
     *
     * ES: Eliminar una configuración de evento.
     *
     * @param id
     * @returns
     */
    deleteEvent = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/delete',
            data: { id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }

    /**
     * EN: Toggle active state for an event configuration.
     *
     * ES: Alternar estado activo de una configuración de evento.
     *
     * @param id
     * @returns
     */
    toggleEvent = async (id: string) => {
        this.response = await this.makeRequest({
            method: 'POST',
            url: ENDPOINT + '/toggle',
            data: { id },
            headers: { "Content-Type": "application/json" }
        }, true);
        return this;
    }
}

